<template>
  <div>
    <va-modal
      class="modal"
      v-model="showPaiement"
      v-on:cancel="closeModal"
      :hideDefaultActions="true"
      disabled
      max-width="100%"
      title="Enregistrer un paiement"
      ><div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md5 pr-4">
            <b>Partenaire:</b> {{ nomPartenaire }}
          </div>
          <div class="flex md3"><b>Facture:</b> {{ nbFacture }}</div>
          <div class="flex md4"><b>Montant:</b> {{ montant }} €</div>
        </div>
        <div class="row row-inside mt-4" v-if="date_paiement">
          Paiement le &nbsp;
          <span
            ><b>
              {{ moment(date_paiement, "YYYY-MM-DD").format("DD/MM/YYYY") }}</b
            ></span
          >
          &nbsp; enregistré par &nbsp;
          <span
            ><b>{{ uname_paiement }}</b></span
          >
        </div>
        <div class="row row-inside mt-4" v-if="date_paiement">
          <div class="flex md4" v-if="!modify_paiement">
            <va-button
              class="fullwidth"
              color="info"
              @click="modify_paiement = true"
              >Modifier le paiement</va-button
            >
          </div>
          <div class="flex md4">
            <va-button
              class="fullwidth"
              color="danger"
              @click="showDeleteConfirm = true"
              >Supprimer le paiement</va-button
            >
          </div>
        </div>
        <div
          class="row row-inside mt-4"
          v-if="!date_paiement || modify_paiement"
        >
          <div class="flex md12 mb-3"><b>Enregistrer un paiement:</b></div>
          <div class="flex md3">
            <va-date-picker
              v-model="date_paiement_mod"
              :config="{ dateFormat: 'd-m-Y' }"
              label="Date de paiement"
            />
          </div>
          <div class="flex md9"></div>
          <div class="flex md6">
            <va-button class="fullwidth" color="info" @click="closeModal"
              >Annuler</va-button
            >
          </div>
          <div class="flex md6">
            <va-button class="fullwidth" @click="savePaiement"
              >Valider</va-button
            >
          </div>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      v-model="showDeleteConfirm"
      okText="Confirmer"
      cancelText="Annuler"
      v-on:cancel="showDeleteConfirm = false"
      v-on:ok="deletePaiement"
      title="Annulation paiement"
    >
      Confirmer l'annulation du paiement?
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  props: ["value", "idfacture"],
  data() {
    return {
      moment: moment,
      showPaiement: false,
      nbFacture: null,
      nomPartenaire: null,
      montant: null,
      date_paiement_mod: moment().format("DD-MM-YYYY"),
      date_paiement: null,
      modify_paiement: false,
      uname_paiement: null,
      showDeleteConfirm: false,
    };
  },
  mounted() {
    this.showPaiement = this.value;
  },

  methods: {
    async deletePaiement() {
      try {
        let params = { idfacture: this.idfacture };
        await axios.delete("/api/publications/paiement", { params: params });
        this.$emit("update");
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast(
          "Erreur lors de la suppression des informations de paiement"
        );
      }
    },
    async savePaiement() {
      try {
        let params = {
          idfacture: this.idfacture,
          datePaiement: moment(this.date_paiement_mod, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
        };

        await axios.put("/api/publications/paiement", params);
        this.$emit("update");
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast(
          "Erreur lors de la sauvegarde des informations de paiement"
        );
      }
    },
    closeModal() {
      this.reset();
      this.$emit("close", false);
      this.$emit("input", false);
    },
    async getInfosPaiement() {
      try {
        let resTmp = await axios.get(
          "/api/publications/facture-infos-paiement",
          {
            params: { idfacture: this.idfacture },
          }
        );

        if (resTmp.data) {
          let facture = resTmp.data;
          this.nbFacture =
            moment(facture.date_facturation, "YYYY-MM-DD").format("YYYY") +
            "/" +
            moment(facture.date_facturation, "YYYY-MM-DD").format("MM") +
            "-" +
            facture.idfacture_publication;

          this.montant = facture.montant_ttc;
          this.nomPartenaire = facture.nom;

          this.date_paiement = facture.date_paiement
            ? facture.date_paiement
            : null;
          this.uname_paiement = facture.uname_paiement
            ? facture.uname_paiement
            : null;
        }

        console.log(resTmp.data);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast(
          "Erreur lors du traitement des informations de paiement"
        );
        this.closeModal();
      }
    },
    reset() {
      this.nbFacture = null;
      this.nomPartenaire = null;
      this.montant = null;
      this.date_paiement_mod = moment().format("DD-MM-YYYY");
      this.date_paiement = null;
      this.uname_paiement = null;
      this.modify_paiement = false;
      this.showDeleteConfirm = false;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  watch: {
    value() {
      // Parent property changed; update internal variables
      this.reset();

      this.showPaiement = this.value;
      if (this.value === true) {
        this.getInfosPaiement();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.forcewidth {
  width: 40vw;
}

.fullwidth {
  width: 95%;
}
</style>
